import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { columns } from './columns'
import { DataTable } from './data-table'
import { useClinicsBySupplierId } from '@/hooks/useClinicsBySupplierId'
import { Skeleton } from '@/components/ui/skeleton'
import { useViewMode } from '@/stores/viewMode'
import { SupplierDeviceStatsCard } from '@/components/SupplierDeviceStatsCard'
import { useDisconnectionAlertDialog } from '@/stores/useDisconnectionAlertDialog'
import { DisconnectionAlertDialog } from '@/components/DisconnectionAlertDialog'
import { AlertScopeType } from '@magnetar/admin-api-interfaces'
import { Bell } from 'lucide-react'

export default function AdSupplierClinicsPage() {
  const { id: supplierId } = useViewMode()
  const { openDialog: openAlertDialog } = useDisconnectionAlertDialog()

  const { clinics, isLoading, isError, mutate } = useClinicsBySupplierId(supplierId.toString())

  if (isError) {
    return (
      <div>
        <div className="text-center text-destructive">載入診所列表失敗。請稍後再試。</div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div>
        <Skeleton className="h-8 w-[200px] mb-4" />
        <Skeleton className="h-[400px] w-full" />
      </div>
    )
  }

  return (
    <div>
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">診所列表</h2>
          <p className="text-muted-foreground mt-2">查看診所資訊及廣告成效</p>
        </div>
        <Button
          variant="outline"
          onClick={() => openAlertDialog(AlertScopeType.ad_supplier, supplierId)}
        >
          <Bell className="h-4 w-4 mr-2" />
          斷線警示設定
        </Button>
      </div>

      <div className="h-4" />

      {/* 設備連接狀態監控 */}
      <SupplierDeviceStatsCard supplierId={supplierId} />

      <div className="h-4" />

      <Card>
        <CardContent className="p-6">
          <DataTable
            columns={columns}
            data={clinics || []}
            supplierId={supplierId}
            meta={{
              reloadData: () => mutate(),
            }}
          />
        </CardContent>
      </Card>

      {/* 斷線警示設定對話框 */}
      <DisconnectionAlertDialog />
    </div>
  )
}
